import React, { useEffect, useRef, useState } from 'react'
import MainFooter from '../Components/footer/MainFooter'
import TopNavigation from '../Components/navigation/TopNavigation'
import titleFlower from './../assets/flower-snip.png';
import waterFlower1 from './../assets/flower-back-water.png';
import waterFlower2 from './../assets/full-flower-back-water.png';
import { Helmet } from 'react-helmet';

function AboutScreen() {
    const sectionsListsRef          = useRef([]);

    const [videoElements, setVideoElements]                    = useState([]);

    useEffect(() => {
      /////
      //Video
            const videos = [
              "/portrait_12068206_.mp4",
              "/portrait_11997751.mp4",
              "/portrait_12176328.mp4",
              "/portrait_14270740.mp4",
              "/portrait_12102756.mp4",
              "/portrait_13621492.mp4",
              "/portrait_12019936.mp4",
              "/portrait_7305165-.mp4",
              "/portrait_11901414-.mp4",
              "/portrait_18161955-.mp4",
              "/portrait_13621593_.mp4",
              "/portrait_12031293-.mp4",
              "/portrait_8479712-.mp4",
              "/portrait_5292675-.mp4",
            ];

       const getRandomUniqueItems = (arr, count) => {
      const shuffled = [...arr].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    };

    const selectedVideos = getRandomUniqueItems(videos, 3);
    //console.log(selectedVideos);
    setVideoElements(selectedVideos);

      /////
      //lists
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
            } else {
              entry.target.classList.remove("animate"); // Optional: remove if you want animation again
            }
          });
        },
        { threshold: 0.3 } // Adjust sensitivity
      );

    sectionsListsRef.current.forEach(el => el && observer.observe(el));

    return () => observer.disconnect();
    }, []);

  return (
    <div className="main-layer">
      <Helmet>
              <title>Lovedripp - About Us </title>
      </Helmet>
      
       <TopNavigation title={"About"} classBack="full-white"/>
        <div className="content-layer">
          <div className="section-item">
              <div className="container">
                  <div className="short-style-banner">
                    <div className="head-container-widget">
                      <h2>About Us</h2>
                      <div className="sub-head-widget">
                      Let us tell you about us.
                      </div>
                    </div>
                  </div>
              </div>
          </div>
          <div className="section-item mgbot60">
            <div className="container">
              <p>We at the LoveDripp believe your love life is a special occasion, worthy to be celebrated across all the seas. We aim to capture what has been unleashed from the depths of your heart into your partners chambers, through an online hosting of the official day of your wedding or anniversary. We call this an Onvite - an <strong>online invite</strong>.</p>
              <p>So you as a host, just creates an event on our platform, share it amongst the people whom you hold dear to attend the event and be able to track who is coming and not coming. You get to approve their lovely messages that edify your day and share the pictures that say more than a thousand words.&nbsp; After sharing your onvite, your loved ones get to purchase gifts that are sent you to enjoy. You have so much to deal with on your wedding day, like seven ways to say “<strong>I do</strong>”, or seven ways to kiss your partner. Not forgetting the romantic vows, you need to prepare.</p>
              <p>Let us have one less thing for you to worry about on "Your big Day".</p>
            </div>
          </div>

          <div className="about__angle-section-a"></div>
            <div className="about-section creamyback2">
                  <div className="video-box box-v1">
                    <div className="sect-circle1 circle1"></div>
                    <div className="sect-circle1 circle2"></div>
                    {
                      videoElements.length > 0 && (
                          <div className="video-about-part video1">
                            <video autoPlay loop muted playsInline className="vid-portrait">
                              <source src={"https://tsdevcut.co.za/videos/lovedrippv/" + videoElements[0]} type="video/mp4" />
                            </video>
                          </div> 
                      )
                    }
                      
                  </div>
                  <div className="content-about-view firstpart">
                    <h2>Share Invite</h2>
                    <ul
                      ref={el => (sectionsListsRef.current[0] = el)} 
                      className="fade-in-items">
                      <li className="show-item-fade">
                          Print out QR Codes if necessary.
                      </li>
                      <li className="show-item-fade">
                          Get a invite link to share with family and friends.
                      </li>
                      <li className="show-item-fade">
                          Invite can never get lost.
                      </li>
                    </ul>
                  </div>             
            </div>

            <div className="about-section grad-creamback2 ">   
              <img src={waterFlower1} className="water-flower water-flower-intro" />                    
                  <div className="content-about-view secondpart">
                    <h2>RSVP</h2>
                    <ul
                      ref={el => (sectionsListsRef.current[1] = el)} 
                      className="fade-in-items">
                      <li className="show-item-fade">
                          View your wedding guest list, which is easily tracked for your management.
                      </li>
                      <li className="show-item-fade">
                          Be able to assess dietary in terms of if anyone has any allergies.
                      </li>
                      <li className="show-item-fade">
                          Invite can never get lost.
                      </li>
                    </ul>
                  </div>
                  <div className="video-box box-v2">
                    {
                      videoElements.length > 0 && (
                        <div className="video-about-part video2">
                          <video autoPlay loop muted playsInline className="vid-portrait">
                            <source src={"https://tsdevcut.co.za/videos/lovedrippv/" + videoElements[1]} type="video/mp4" />
                          </video>
                        </div>  
                      )
                    }
                      
                  </div>
            </div>

            <div className="about-section">
              <img src={waterFlower2} className="water-flower water-flower-base" />   
                    <div className="video-box box-v3">
                      {
                        videoElements.length > 0 && (
                            <div className="video-about-part video3">
                              <video autoPlay loop muted playsInline className="vid-portrait">
                                <source src={`https://tsdevcut.co.za/videos/lovedrippv${videoElements[2]}`} type="video/mp4" />
                              </video>
                            </div>  
                        )
                      }
                      
                  </div>
                  <div className="content-about-view thirdpart">
                    <h2>Venue Locator</h2>
                    <ul 
                      ref={el => (sectionsListsRef.current[2] = el)}
                      className="fade-in-items">
                      <li className="show-item-fade">
                          Share Wedding Venue along with the time to start and the time to end.
                      </li>
                      <li className="show-item-fade">
                          Share the reception location along with the time to start and the time to end.
                      </li>
                    </ul>
                  </div>          
            </div>
          
        </div>
      <MainFooter />
    </div>
  )
}

export default AboutScreen